import script from "./ReportReasonsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportReasonsListView.vue?vue&type=script&setup=true&lang=js"

import "./ReportReasonsListView.vue?vue&type=style&index=0&id=1be33dbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be33dbd"]])

export default __exports__